import styled from 'styled-components';
import {IImageSource} from './index';

export const Container = styled.main<{topBackgroundImage: string}>`
	background-image: url(${props => props.topBackgroundImage}), radial-gradient(50% 50% at 50% 50%, #FFF 0%, #EAF2FF 100%);
	background-position: top center;
	background-repeat: no-repeat;
	background-size: 150% auto;
	padding: 0 15px 50px;
	font-family: Montserrat, sans-serif;
	@media all and (min-width: 992px) {
		background-size: 100% auto;
	}
`

export const MenuStyled = styled.div`
	position: absolute;
	right: 0;
	top: 20px;
	display: none;
	width: 100%;
	max-width: 1024px;
	
	@media all and (min-width: 992px) {
		display: flex;
	}
	
	ul {
		list-style: none;
		margin: 0 3px;
		padding: 0;
		display: inline-block;
		flex: 1;

      &:hover {
        li a.parent {
          &:after {
            border-top: none;
            border-bottom: 5px solid #999;
          }
          
          &:hover:after {
            border-bottom: 5px solid #fff;
          }
        }
      }
		
		li {
			
			a.parent {
				position: relative;
				&:after {
					content: '';
					position: absolute;
					width: 0;
					height: 0;
					border-left: 5px solid transparent;
					border-right: 5px solid transparent;
					border-top: 5px solid #999;
					right: 14px;
					top: calc(50% - 3px);
				}
			}
			
			&:first-child {
				a {
					border-radius: 5px;
				}
			}
			&:not(:first-child) {
				display: none;
			}
			&:nth-child(2) {
				margin-top: 5px;
				a {
					border-top-left-radius: 5px;
					border-top-right-radius: 5px;
				}
			}
			&:last-child {
				a {
					border-bottom-left-radius: 5px;
					border-bottom-right-radius: 5px;
				}
			}
		}
		
		&:hover, &:focus, &:active {
			li:not(:first-child) {
				display: block;
			}
		}
		a {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 50px;
			background-color: #fff;
			color: #999;
			&:hover, &:focus, &:active {
				background-color: #FF7C54;
				color: #fff;
			}
		}
	}

`
export const ContentContainer = styled.div<{narrowedWidth?: boolean; background?: string}>`
	position: relative;
	width: 100%;
	max-width: ${({narrowedWidth}) => narrowedWidth ? 1280 : 1600}px;
	margin: 0 auto 50px;
	background: ${({background}) => background || 'transparent'};
`
export const ActionButton = styled.a`
	display: inline-block;
	border-radius: 5px;
	background: #FF7C54;
	padding: 5px;
	min-width: 276px;
	color: #FFF;
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
`
